export enum BmkAtcTpCd {
  MP_LIST = 'MP_LIST', // 설비변경점 즐겨찾기(관심항목-그리드 북마크)
  MP_ITEM = 'MP_ITEM', // 설비변경점 즐겨찾기(조회조건설정)
}

export enum BmkTgtTpCd {
  BMK_COND = 'BMK_COND', // 설비변경점 즐겨찾기(관심항목-그리드 북마크)
  INQ_COND = 'INQ_COND', // 설비변경점 즐겨찾기(조회조건설정)
  FLD_HID = 'FLD_HID', // 그리드 필드 숨김
}

export interface BookmarkCondition {
  bmkTgtTpCd?: string;
  bmkAtcTpCd?: string; // 즐겨찾기 항목 유형 코드
  bmkGrDesc?: string; // 메뉴 URL (화면 구분자)
}

export interface BookmarkMaster {
  bmkGrId?: string;
  bmkTgtTpCd?: string; // 즐겨찾기대상유형코드
  bmkGrDesc?: string;
  bmkAtcTpCd?: string; // 즐겨찾기항목유형코드
  atchFileGrId?: string;
  useYn?: string;
  optValCtn1?: string; // 즐겨찾기(조회조건설정명)
  optValCtn2?: string;
  optValCtn3?: string;
  optValCtn4?: string;
  optValCtn5?: string;
  detailList?: BookmarkDtail[];
}

export interface BookmarkDtail {
  bmkId?: string;
  bmkTgtId?: string;
  bmkGrId?: string; // 즐겨찾기대상유형코드
  bmkGrDesc?: string;
  bmkAtcTpCd?: string; // 즐겨찾기항목유형코드
  bmkTgtUrl?: string; // 즐겨찾기항목유형코드
  atchFileGrId?: string;
  useYn?: string;
  optValCtn1?: string; // 즐겨찾기(조회조건설정 값)
  optValCtn2?: string;
  optValCtn3?: string;
  optValCtn4?: string;
  optValCtn5?: string;
}
